export default __webpack_public_path__ + "static/media/Ballroll_00059.f62bc7ac.png";